export default {
  chartNetMatchValue: {
    chartTitle: 'GIÁ TRỊ RÒNG THEO LOẠI NHÀ ĐẦU TƯ',
    tooltipIndividual: 'GT Cá Nhân Ròng  : {0} Tỷ',
    tooltipInstitution: 'GT Tổ Chức Trong Nước Ròng : {0} Tỷ',
    tooltipProprietary: 'GT Tự Doanh Ròng : {0} Tỷ',
    tooltipForeign: 'GT Nước Ngoài Ròng : {0} Tỷ',
    inforPrice: '{0} : {1}',
    category: 'Thời gian : {0}',
    legendIndividual: 'Cá Nhân',
    legendInstitution: 'Tổ Chức Trong Nước ',
    legendProprietary: 'Tự Doanh',
    legendForeign: 'Nước Ngoài',
    legendCode: 'Giá',
    yAxis1Title: 'Tỷ',
    yAxis2Title: 'Chỉ số giá',
  },
  listTimeRangeByKey: {
    Daily: 'Theo ngày',
    Weekly: 'Theo tuần',
    Monthly: 'Theo tháng',
  },
  listValueType: {
    MatchValue: 'GT KHỚP LỆNH',
    TotalValue: 'TỔNG GTGD',
  },

  heatmap: {
    tooltipBuyTitle: 'GT Mua: ',
    tooltipBuyNetTitle: 'GT Ròng: ',
    investorBuyNetTitle: 'GT Mua Ròng: ',
    tooltipSellTitle: 'GT Bán: ',
    tooltipSellNetTitle: 'GT Ròng: ',
    investorSellNetTitle: 'GT Bán Ròng: ',
  },

  INDIVIDUAL: 'Cá Nhân',
  INSTITUTION: 'Tổ Chức Trong Nước',
  PROPRIETARY: 'Tự Doanh',
  FOREIGN: 'Nước Ngoài',

  TOTAL_VALUE: 'Tổng GTGD',
  NET_TOTAL_VALUE: 'Tổng GTGD Ròng',
  MATCH_VALUE: 'GT Khớp Lệnh',
  NET_MATCH_VALUE: 'GT Khớp Lệnh Ròng',
  DEAL_VALUE: 'GT Thỏa Thuận',
  NET_DEAL_VALUE: 'GT Thỏa Thuận Ròng',
};
